module.exports = __webpack_public_path__ + "img/logo-colorfull.5763f3ea.png";